(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-country-restriction"] && !Shopify.designMode) return;
  try {
    
    if( window.innerWidth < 768 ) {
      var filterEle = document.querySelector('.gf-filter-trigger'); 
      var waitForFilterEl = function(selector, maxtries=false,interval=100, callback) {
          const poller = setInterval(() => {
          const el = jQuery(selector)
          const retry = maxtries === false || maxtries-- > 0
          if (retry && el.length < 1) return // will try again
          clearInterval(poller)
          callback(el || null)
        }, interval);
      };
      waitForFilterEl(filterEle, 10, 100, function() {
        jQuery("section.products .content.header .d-flex").append( jQuery(".gf-filter-trigger") );
      });
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  if( window.innerWidth < 768 ) {
    var filterEle = document.querySelector('.gf-filter-trigger'); 
    var waitForFilterEl = function(selector, maxtries=false,interval=100, callback) {
        const poller = setInterval(() => {
        const el = jQuery(selector)
        const retry = maxtries === false || maxtries-- > 0
        if (retry && el.length < 1) return // will try again
        clearInterval(poller)
        callback(el || null)
      }, interval);
    };
    waitForFilterEl(filterEle, 10, 100, function() {
      jQuery("section.products .content.header .d-flex").append( jQuery(".gf-filter-trigger") );
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('mainNavbar');
      this.headerBounds = {};
      this.currentScrollTop = 110;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if( this.header.querySelector('.navbar-toggler.collapsed') )  {
        this.header.classList.add('d-none', 'fixed-top');
        this.closeMenuDisclosure();
      };
    }

    reveal() {
      this.header.classList.add('d-block', 'fixed-top', 'animate');
      this.header.classList.remove('d-none');
    }

    reset() {
      this.header.classList.remove('d-block', 'fixed-top', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header-buynow"]) return;
  try {
    
  var productObj = JSON.parse(document.getElementById('ProductJson').innerHTML);
  var metafieldObj = JSON.parse(document.getElementById('MetafieldJson').innerHTML);
  var variantObj = getVariant( document.querySelector('[name="id"]').value );

  function setVariant(variant) {
    variantObj = variant;
    
    jQuery('[variant-title]').html( variant.title );
    jQuery('[variant-select] option').attr("selected",false);
    jQuery('[variant-select] option[value="'+ variant.id +'"]').attr("selected",true);

    // update UI items
    updatePrice(); // Updates display price and sale display
    updateImages();
    updateCTA( variant.available ); // Display Buy CTA for Variant
    updateHistoryState(); // Adds Variant ID to URL for deeplinking
  };

  function updateShopifyPaymentsMonthlyPrice(newPrice) {
    const timeout = 3000;
    const interval = 100;
    const start = Date.now();
  
    function calculateMonthlyInstallment(purchaseAmount, apr = 15, months) {
      const monthlyRate = apr / 100 / 12;
      const n = months;
      const monthlyPayment = (monthlyRate * purchaseAmount) / (1 - Math.pow(1 + monthlyRate, -n));
      return monthlyPayment;
    }
  
    const check = setInterval(function () {
      const host = document.querySelector('shopify-payment-terms'); // replace with correct shadow host tag or selector
      if (host && host.shadowRoot) {
        const el = host.shadowRoot.getElementById('shopify-installments-content');
        if (el) {
          const span = el.querySelector('span');
          if (span) {
            const months = newPrice < 15000 ? 4 : 12;
            const monthly = calculateMonthlyInstallment(newPrice, 15, months);
            span.textContent = Shopify.formatMoney(Math.round(monthly));
            clearInterval(check);
          }
        }
      }
  
      if (Date.now() - start >= timeout) {
        clearInterval(check);
        console.warn('Could not find shopify-installments-content in shadow DOM within 3 seconds.');
      }
    }, interval);
  }

  function updatePrice() {
    var variantMetafields = getVariantMetafields();
    var productPrice = variantObj.price;
    var originalPrice = variantObj.compare_at_price;
  
    var productEl = document.querySelector('.product-header');
    // will use variant strike price percentage instead of theme settings' percentage by Bill Kim
    var hasStrikePrice = productEl?.dataset?.strikeEnabled === 'true' && variantMetafields.strike_price_percentage > 0;
    var strikeDiscount = variantMetafields.strike_price_percentage;
    // var hasStrikePrice = productEl?.dataset?.strikeEnabled === 'true';
    // var strikeDiscount = parseFloat(productEl?.dataset?.strikeValue || '0');
  
    // Apply strike price if valid
    if (hasStrikePrice && strikeDiscount > 0) {
      originalPrice = productPrice; // Save original before applying strike
      productPrice = Math.ceil(productPrice * ((100 - strikeDiscount) / 100));
    }
  
    // Update main price
    document.querySelector(".product-header [product-price]").innerHTML = Shopify.formatMoney(productPrice);
    updateShopifyPaymentsMonthlyPrice(productPrice);
  
    // If strike or compare_at_price is valid, show original price
    if (productPrice < originalPrice) {
      document.querySelector(".product-header [original-price]").innerHTML = Shopify.formatMoney(originalPrice);
      jQuery('.product-header [original-price], .badge-sale').removeClass('d-none');
    } else {
      jQuery('.product-header [original-price], .badge-sale').addClass('d-none');
    }
  }

  function updateCTA(is_available) {

    if( is_available == true ) {
      jQuery('.klaviyo-bis-trigger').hide();
      jQuery('#AddToCartButton').removeAttr("disabled");
      jQuery('#AddToCartButton span').html( lang_add_to_cart );
    } else {
      jQuery('.klaviyo-bis-trigger').show();
      jQuery('#AddToCartButton').attr("disabled", true);
      jQuery('#AddToCartButton span').html( lang_sold_out );
    };
  };

  function updateImages() {
    var variant_id = variantObj.id;
    var variant_image = variantObj.featured_image;
    var variant_carousel = jQuery("#variant-carousel-"+variant_id);
    var media_carousel = jQuery("#mip-carousel div.carousel");

    // Always open on the FIRST image of the (variant's) media set, not the variant's featured image
    window._mipStartIdx = 0;
    // If product has variants load MIP Variants
    if( variant_carousel.length > 0 ) {
      jQuery("#mip-carousel > div").replaceWith( "<div class='carousel'>" + variant_carousel.html() + "</div>" ); // Replace default image loaded with variant container
      initMip();
    } else if(media_carousel.length < 1) {
      var sizedSrcset = Shopify.resizeImage(variant_image.src, '500x'); //resize
      var sizedSrc = Shopify.resizeImage(variant_image.src, '800x'); //resize
      jQuery("#mip-carousel > div").replaceWith('<div><picture><source media="(max-width: 500px)" srcset="'+sizedSrcset+'"><img src="'+sizedSrc+'" width="800" height="800" class="img-fluid" alt="'+product.title+'"></picture></div>');
    } else {
      initMip();
      jQuery('#mip-carousel div.carousel.slick-initialized').slick('slickGoTo', 0 );
    };

    initMediaZoom();

  };

  function initMediaZoom() {
    var mediaZoomModalEl = document.getElementById('mediaZoom');
    var mediaZoomModal = bootstrap.Modal.getOrCreateInstance(mediaZoomModalEl);

    mediaZoomModalEl.addEventListener('hidden.bs.modal', event => {
       mediaZoomModalEl.querySelector('.modal-body').innerHTML = '';
    });

    var mediaItemsList = [].slice.call(document.querySelectorAll('#mip-carousel .img-fluid'));
    var mediaItems = mediaItemsList.map(function (mediaEle) {
      mediaEle.addEventListener('click', function(evt){

        var slideIndex = Array.from(evt.target.parentElement.parentElement.children).indexOf(evt.target.parentElement);

        var mediaClone = document.querySelector('.media #mip-carousel').cloneNode(true);
        mediaZoomModalEl.querySelector('.modal-body').appendChild( mediaClone );
        
        jQuery('.modal-body .carousel').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: slideIndex,
          lazyLoad: 'ondemand',
          touchMove: true,
          arrows: true,
          dots: false
        });

        mediaZoomModal.show();
        
      });
    });
  };
  
  /* ── Desktop gallery builder ── */
  function buildMipGallery(carousel, startIdx) {
    startIdx = startIdx || 0;
    var mipEl   = document.getElementById('mip-carousel');
    var mediaEl = mipEl ? mipEl.parentElement : null;
    if (!mediaEl) return;

    // Remove any previous gallery instance
    var old = mediaEl.querySelector('.mip-gallery');
    if (old) old.remove();

    // Collect media (images + video) from carousel slides
    var slides = [].slice.call(carousel.querySelectorAll(':scope > div'));
    var images = [];
    slides.forEach(function(slide) {
      var video = slide.querySelector('video');
      if (video) {
        var srcHtml = '';
        var vsources = slide.querySelectorAll('video source');
        if (vsources.length) {
          [].forEach.call(vsources, function(s){ srcHtml += '<source src="' + s.getAttribute('src') + '"' + (s.getAttribute('type') ? ' type="' + s.getAttribute('type') + '"' : '') + '>'; });
        } else if (video.getAttribute('src')) {
          srcHtml = '<source src="' + video.getAttribute('src') + '">';
        }
        var poster = video.getAttribute('poster') || '';
        images.push({ type: 'video', src: poster, alt: '', zoom: poster, sources: srcHtml });
      } else {
        var img = slide.querySelector('img');
        if (img) {
          images.push({
            type: 'image',
            src:  img.getAttribute('data-src') || img.src,
            alt:  img.alt || '',
            zoom: img.getAttribute('data-zoom') || img.getAttribute('data-src') || img.src
          });
        }
      }
    });
    if (!images.length) return;

    var current      = Math.min(Math.max(0, startIdx), images.length - 1);
    var thumbOffset  = 0;
    var THUMBS_PAGE  = 7;

    // Build gallery DOM
    var gallery = document.createElement('div');
    gallery.className = 'mip-gallery';

    var mainsRow = document.createElement('div');
    mainsRow.className = 'mip-gallery-mains';
    var slotL = document.createElement('div');
    slotL.className = 'mip-gallery-main-slot mip-slot-left';
    var slotR = document.createElement('div');
    slotR.className = 'mip-gallery-main-slot mip-slot-right';
    mainsRow.appendChild(slotL);
    mainsRow.appendChild(slotR);

    // Overlay nav arrows
    var prevNavBtn = document.createElement('button');
    prevNavBtn.type = 'button';
    prevNavBtn.className = 'mip-nav-btn mip-nav-prev';
    prevNavBtn.setAttribute('aria-label', 'Previous image');
    prevNavBtn.innerHTML = '<svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var nextNavBtn = document.createElement('button');
    nextNavBtn.type = 'button';
    nextNavBtn.className = 'mip-nav-btn mip-nav-next';
    nextNavBtn.setAttribute('aria-label', 'Next image');
    nextNavBtn.innerHTML = '<svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    mainsRow.appendChild(prevNavBtn);
    mainsRow.appendChild(nextNavBtn);

    gallery.appendChild(mainsRow);

    var thumbsOuter = document.createElement('div');
    thumbsOuter.className = 'mip-thumbs-outer';
    var thumbPrevBtn = document.createElement('button');
    thumbPrevBtn.type = 'button';
    thumbPrevBtn.className = 'mip-thumb-arrow mip-thumb-prev';
    thumbPrevBtn.setAttribute('aria-label', 'Previous thumbnails');
    thumbPrevBtn.innerHTML = '<svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var thumbsInner = document.createElement('div');
    thumbsInner.className = 'mip-thumbs-inner';
    var thumbNextBtn = document.createElement('button');
    thumbNextBtn.type = 'button';
    thumbNextBtn.className = 'mip-thumb-arrow mip-thumb-next';
    thumbNextBtn.setAttribute('aria-label', 'More thumbnails');
    thumbNextBtn.innerHTML = '<svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    thumbsOuter.appendChild(thumbPrevBtn);
    thumbsOuter.appendChild(thumbsInner);
    thumbsOuter.appendChild(thumbNextBtn);
    gallery.appendChild(thumbsOuter);

    // Insert gallery after #mip-carousel and hide the original
    mipEl.insertAdjacentElement('afterend', gallery);
    mipEl.style.display = 'none';

    function slotMarkup(item, active) {
      if (item.type === 'video') {
        return '<video class="img-fluid mip-video" muted loop playsinline controls' + (active ? ' autoplay' : '') + ' poster="' + (item.src || '').replace(/"/g,'&quot;') + '" style="width:100%;display:block;">' + item.sources + '</video>';
      }
      return '<img src="' + item.src + '" alt="' + (item.alt || '').replace(/"/g,'&quot;') + '" class="img-fluid">';
    }
    function renderMains() {
      var rIdx = (current + 1) % images.length;
      slotL.innerHTML = slotMarkup(images[current], true);
      slotR.innerHTML = slotMarkup(images[rIdx], false);
      var v = slotL.querySelector('video');
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
    }

    function renderThumbs() {
      thumbsInner.innerHTML = '';
      for (var i = 0; i < images.length; i++) {
        var el = document.createElement('div');
        el.className = 'mip-thumb-item' + (i === current ? ' mip-active' : '');
        el.setAttribute('data-idx', i);
        el.innerHTML = '<img src="' + images[i].src + '" alt="' + (images[i].alt || '').replace(/"/g,'&quot;') + '" loading="lazy">' + (images[i].type === 'video' ? '<span class="mip-thumb-play" aria-hidden="true"></span>' : '');
        thumbsInner.appendChild(el);
      }
      updateThumbArrows();
      scrollActiveThumbIntoView();
    }

    /* Show/hide + enable/disable the arrows based on overflow & scroll position */
    function updateThumbArrows() {
      var maxScroll = thumbsInner.scrollWidth - thumbsInner.clientWidth - 1;
      var hasOverflow = maxScroll > 0;
      thumbPrevBtn.style.display = hasOverflow ? 'flex' : 'none';
      thumbNextBtn.style.display = hasOverflow ? 'flex' : 'none';
      thumbPrevBtn.disabled = thumbsInner.scrollLeft <= 0;
      thumbNextBtn.disabled = thumbsInner.scrollLeft >= maxScroll;
    }

    /* Keep the active thumbnail visible within the strip */
    function scrollActiveThumbIntoView() {
      var activeEl = thumbsInner.querySelector('.mip-thumb-item.mip-active');
      if (!activeEl) return;
      var elLeft  = activeEl.offsetLeft;
      var elRight = elLeft + activeEl.offsetWidth;
      if (elLeft < thumbsInner.scrollLeft) {
        thumbsInner.scrollTo({ left: Math.max(0, elLeft - 8), behavior: 'smooth' });
      } else if (elRight > thumbsInner.scrollLeft + thumbsInner.clientWidth) {
        thumbsInner.scrollTo({ left: elRight - thumbsInner.clientWidth + 8, behavior: 'smooth' });
      }
    }

    function scrollThumbsBy(dir) {
      var step = (72 + 8) * 3; /* ~3 thumbnails */
      thumbsInner.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    // Thumbnail click → set as main image
    thumbsInner.addEventListener('click', function(e) {
      var item = e.target.closest('.mip-thumb-item');
      if (!item) return;
      current = parseInt(item.getAttribute('data-idx'), 10);
      renderMains();
      renderThumbs();
    });

    // Left / right thumbnail scroll arrows
    thumbPrevBtn.addEventListener('click', function() { scrollThumbsBy(-1); });
    thumbNextBtn.addEventListener('click', function() { scrollThumbsBy(1); });
    thumbsInner.addEventListener('scroll', updateThumbArrows);
    window.addEventListener('resize', updateThumbArrows);

    // Prev / Next overlay nav arrows
    prevNavBtn.addEventListener('click', function() {
      current = (current - 1 + images.length) % images.length;
      renderMains();
      renderThumbs();
    });
    nextNavBtn.addEventListener('click', function() {
      current = (current + 1) % images.length;
      renderMains();
      renderThumbs();
    });

    // Zoom on main image click
    [slotL, slotR].forEach(function(slot, si) {
      slot.addEventListener('click', function() {
        var zIdx = si === 0 ? current : (current + 1) % images.length;
        if (images[zIdx].type === 'video') return;   /* don't zoom videos */
        var modalEl = document.getElementById('mediaZoom');
        if (!modalEl) return;
        var modalBody = modalEl.querySelector('.modal-body');
        modalBody.innerHTML = '<div style="text-align:center;padding:20px"><img src="' + images[zIdx].zoom + '" style="max-width:100%;max-height:80vh;object-fit:contain" alt=""></div>';
        bootstrap.Modal.getOrCreateInstance(modalEl).show();
      });
    });

    renderMains();
    renderThumbs();
  }

  function initMip() {
    var carousel_element = jQuery('#mip-carousel div.carousel').not('.slick-initialized');

    if ( carousel_element.length > 0 && window.innerWidth < 768 ) {
      // Mobile: restore #mip-carousel, hide any desktop gallery
      var mipEl2 = document.getElementById('mip-carousel');
      if (mipEl2) mipEl2.style.display = '';
      var galleryEl = mipEl2 ? mipEl2.parentElement.querySelector('.mip-gallery') : null;
      if (galleryEl) galleryEl.remove();

      carousel_element.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        touchMove: true,
        arrows: true,
        dots: true,
        prevArrow: '<button class="slick-prev" type="button" aria-label="Previous"><svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next" type="button" aria-label="Next"><svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      });
      /* Recalc slide widths so each fills the viewport (fixes the next-image peek) */
      setTimeout(function(){ try { carousel_element.slick('setPosition'); } catch(e){} }, 60);
      jQuery(window).on('load', function(){ try { carousel_element.slick('setPosition'); } catch(e){} });

    } else if ( carousel_element.length > 0 && window.innerWidth >= 768 ) {
      // Desktop: custom 2-main + thumbnails gallery
      buildMipGallery(carousel_element[0], window._mipStartIdx || 0);
    }
  }

  function updateHistoryState() {
    var querystring = new URLSearchParams(window.location.search)
    querystring.set('variant', variantObj.id);
    /* querystring.set('selling_plan', (sellingPlan)?sellingPlan.selling_plan_id:''); */
    querystring = '?' + querystring.toString();
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + querystring;
    window.history.replaceState({path: newurl}, '', newurl);
  };

  function getVariant( variantId=false ) {
    var currentVariant = (variantObj)?variantObj:false;
    if( !variantId ) { variantId = document.querySelector('form [name="id"]').value; }
    if( currentVariant && currentVariant.id == variantId ) {
      variantObj = variantObj;
      return variantObj;
    } else {
      var variants = productObj.variants;
      var variant = variants.find(({ id }) => id === Number(variantId));
      variantObj = variant;
      return variant;
    };
  };

  function getVariantMetafields( variantId=false ) {
    if( !variantId ) { variantId = document.querySelector('form [name="id"]').value; }
    return metafieldObj.find(({ id }) => id === Number(variantId));
  };

  function changeSpecs(variantId) {
    var variantMetafields = getVariantMetafields(variantId);
    variantMetafields = variantMetafields.specifications[0];
    var ele = document.querySelector('.specifications');
    if( ele && variantMetafields!=null && typeof variantMetafields  === 'object' ) {
      Object.keys(variantMetafields).forEach(function(key,index, value) {
        if(key == 'product') { return; }
        var classTarget = (key.includes('packed'))?'.packed':'.assembled';
        var metaValue = variantMetafields[key];
        var targetEle = ele.querySelector('.'+key.replace('packed_','')+' '+classTarget);
        targetEle.innerHTML = '<span>'+metaValue[0].value+'</span><span>'+metaValue[0].unit+'</span>';
      });   
    };
  };
  
  /* JS loaded: hide dropdown and show option swap */
  document.querySelector('.variant-select').style.display = "none";
  var options_ele = document.querySelectorAll('.product-options');
  [].forEach.call(options_ele, function(ele) {
    ele.style.display = "block";
  });

  jQuery('.product-options :radio, .product-options select').on('change', function () {

    if( jQuery(this).is("input") ) {
      jQuery("#selected-option-"+jQuery(this).attr('name').toLowerCase().replace(/ /g,'-')).text( jQuery(this).val() );
    }

    /* loop through all available options and get currently selected value */
    
    var selected_options = [];
    productObj.options.forEach(async function(option) {
      if( document.querySelector('[data-option="'+option+'"] input') ) {
        selected_options.push( document.querySelector('[data-option="'+option+'"] input:checked').value );
      } else if(document.querySelector('[data-option="'+option+'"] select') ) {
        selected_options.push( document.querySelector('[data-option="'+option+'"] select').value );
      }
    });

    /* find variant by selected value(s) */
    var selected_variant = productObj.variants.find(function(variant, index) {
      if(selected_options.length == 3 && variant.option1 == selected_options[0] && variant.option2 == selected_options[1] && variant.option3 == selected_options[2] ) {
        return true;
      } else if(selected_options.length == 2 && variant.option1 == selected_options[0] && variant.option2 == selected_options[1] ) {
        return true;
      } else if(selected_options.length == 1 && variant.option1 == selected_options[0]) {
        return true;
      } else {
		return false;
	  }
    });

	/* If variant does't exist, show as sold out w/o notify ability */
    if(!selected_variant) { 
		//alert("That combination isn't available. Choose another option.");
        updateCTA( false );
		jQuery('.klaviyo-bis-trigger').hide();
		return false;
	};

    setVariant( selected_variant );
    changeSpecs( selected_variant.id );
  });

  /* Move the title above the gallery only when the layout is actually stacked
     (<768). On iPads (768-991) the columns are side by side, so the title
     must stay inside the description column. matchMedia matches the CSS
     breakpoint exactly (jQuery width() excludes the scrollbar). */
  if (window.matchMedia('(max-width: 767.98px)').matches) {
    jQuery('#product_header').prependTo(".product-header > div > div.d-flex");
    jQuery('#product_header').addClass("content");
  };

  /* The gallery (slick on mobile, two-image gallery on desktop) and the title
     placement are chosen at load time. Re-apply both whenever the viewport
     crosses the 768px breakpoint so no refresh is needed. */
  var _hxMobileMQ  = window.matchMedia('(max-width: 767.98px)');
  var _hxWasMobile = _hxMobileMQ.matches;
  var _hxResizeTimer;
  jQuery(window).on('resize', function(){
    clearTimeout(_hxResizeTimer);
    _hxResizeTimer = setTimeout(function(){
      var nowMobile = _hxMobileMQ.matches;
      if (nowMobile === _hxWasMobile) return;
      _hxWasMobile = nowMobile;

      var $carousel = jQuery('#mip-carousel div.carousel');
      var mipEl     = document.getElementById('mip-carousel');

      if (nowMobile) {
        /* Desktop → mobile: drop the desktop gallery, show the slick carousel */
        var galleryEl = mipEl ? mipEl.parentElement.querySelector('.mip-gallery') : null;
        if (galleryEl) galleryEl.remove();
        if (mipEl) mipEl.style.display = '';
        if ($carousel.length && !$carousel.hasClass('slick-initialized')) {
          initMip();
        }
        /* Title above the gallery (stacked layout) */
        jQuery('#product_header').prependTo('.product-header > div > div.d-flex').addClass('content');
      } else {
        /* Mobile → desktop: unslick and build the two-image gallery */
        if ($carousel.length && $carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
        initMip();
        /* Title back inside the description column */
        jQuery('#product_header').removeClass('content').prependTo('.product-header .description > .content');
      }
    }, 250);
  });

  setVariant(variantObj);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    
  var productObj = JSON.parse(document.getElementById('ProductJson').innerHTML);
  var metafieldObj = JSON.parse(document.getElementById('MetafieldJson').innerHTML);
  var variantObj = getVariant( document.querySelector('[name="id"]').value );

  function setVariant(variant) {
    variantObj = variant;
    
    jQuery('[variant-title]').html( variant.title );
    jQuery('[variant-select] option').attr("selected",false);
    jQuery('[variant-select] option[value="'+ variant.id +'"]').attr("selected",true);

    // update UI items
    updatePrice(); // Updates display price and sale display
    updateImages();
    updateCTA( variant.available ); // Display Buy CTA for Variant
    updateHistoryState(); // Adds Variant ID to URL for deeplinking
  };

  function updateShopifyPaymentsMonthlyPrice(newPrice) {
    const timeout = 3000;
    const interval = 100;
    const start = Date.now();
  
    function calculateMonthlyInstallment(purchaseAmount, apr = 15, months) {
      const monthlyRate = apr / 100 / 12;
      const n = months;
      const monthlyPayment = (monthlyRate * purchaseAmount) / (1 - Math.pow(1 + monthlyRate, -n));
      return monthlyPayment;
    }
  
    const check = setInterval(function () {
      const host = document.querySelector('shopify-payment-terms'); // replace with correct shadow host tag or selector
      if (host && host.shadowRoot) {
        const el = host.shadowRoot.getElementById('shopify-installments-content');
        if (el) {
          const span = el.querySelector('span');
          if (span) {
            const months = newPrice < 15000 ? 4 : 12;
            const monthly = calculateMonthlyInstallment(newPrice, 15, months);
            span.textContent = Shopify.formatMoney(Math.round(monthly));
            clearInterval(check);
          }
        }
      }
  
      if (Date.now() - start >= timeout) {
        clearInterval(check);
        console.warn('Could not find shopify-installments-content in shadow DOM within 3 seconds.');
      }
    }, interval);
  }

  function updatePrice() {
    var variantMetafields = getVariantMetafields();
    var productPrice = variantObj.price;
    var originalPrice = variantObj.compare_at_price;
  
    var productEl = document.querySelector('.product-header');
    // will use variant strike price percentage instead of theme settings' percentage by Bill Kim
    var hasStrikePrice = productEl?.dataset?.strikeEnabled === 'true' && variantMetafields.strike_price_percentage > 0;
    var strikeDiscount = variantMetafields.strike_price_percentage;
    // var hasStrikePrice = productEl?.dataset?.strikeEnabled === 'true';
    // var strikeDiscount = parseFloat(productEl?.dataset?.strikeValue || '0');
  
    // Apply strike price if valid
    if (hasStrikePrice && strikeDiscount > 0) {
      originalPrice = productPrice; // Save original before applying strike
      productPrice = Math.ceil(productPrice * ((100 - strikeDiscount) / 100));
    }
  
    // Update main price
    document.querySelector(".product-header [product-price]").innerHTML = Shopify.formatMoney(productPrice);
    updateShopifyPaymentsMonthlyPrice(productPrice);
  
    // If strike or compare_at_price is valid, show original price
    if (productPrice < originalPrice) {
      document.querySelector(".product-header [original-price]").innerHTML = Shopify.formatMoney(originalPrice);
      jQuery('.product-header [original-price], .badge-sale').removeClass('d-none');
    } else {
      jQuery('.product-header [original-price], .badge-sale').addClass('d-none');
    }
  }

  function updateCTA(is_available) {

    if( is_available == true ) {
      jQuery('.klaviyo-bis-trigger').hide();
      jQuery('#AddToCartButton').removeAttr("disabled");
      jQuery('#AddToCartButton span').html( lang_add_to_cart );
    } else {
      jQuery('.klaviyo-bis-trigger').show();
      jQuery('#AddToCartButton').attr("disabled", true);
      jQuery('#AddToCartButton span').html( lang_sold_out );
    };
  };

  function updateImages() {
    var variant_id = variantObj.id;
    var variant_image = variantObj.featured_image;
    var variant_carousel = jQuery("#variant-carousel-"+variant_id);
    var media_carousel = jQuery("#mip-carousel div.carousel");

    // Always open on the FIRST image of the (variant's) media set, not the variant's featured image
    window._mipStartIdx = 0;
    // If product has variants load MIP Variants
    if( variant_carousel.length > 0 ) {
      jQuery("#mip-carousel > div").replaceWith( "<div class='carousel'>" + variant_carousel.html() + "</div>" ); // Replace default image loaded with variant container
      initMip();
    } else if(media_carousel.length < 1) {
      var sizedSrcset = Shopify.resizeImage(variant_image.src, '500x'); //resize
      var sizedSrc = Shopify.resizeImage(variant_image.src, '800x'); //resize
      jQuery("#mip-carousel > div").replaceWith('<div><picture><source media="(max-width: 500px)" srcset="'+sizedSrcset+'"><img src="'+sizedSrc+'" width="800" height="800" class="img-fluid" alt="'+product.title+'"></picture></div>');
    } else {
      initMip();
      jQuery('#mip-carousel div.carousel.slick-initialized').slick('slickGoTo', 0 );
    };

    initMediaZoom();

  };

  function initMediaZoom() {
    var mediaZoomModalEl = document.getElementById('mediaZoom');
    var mediaZoomModal = bootstrap.Modal.getOrCreateInstance(mediaZoomModalEl);

    mediaZoomModalEl.addEventListener('hidden.bs.modal', event => {
       mediaZoomModalEl.querySelector('.modal-body').innerHTML = '';
    });

    var mediaItemsList = [].slice.call(document.querySelectorAll('#mip-carousel .img-fluid'));
    var mediaItems = mediaItemsList.map(function (mediaEle) {
      mediaEle.addEventListener('click', function(evt){

        var slideIndex = Array.from(evt.target.parentElement.parentElement.children).indexOf(evt.target.parentElement);

        var mediaClone = document.querySelector('.media #mip-carousel').cloneNode(true);
        mediaZoomModalEl.querySelector('.modal-body').appendChild( mediaClone );
        
        jQuery('.modal-body .carousel').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: slideIndex,
          lazyLoad: 'ondemand',
          touchMove: true,
          arrows: true,
          dots: false
        });

        mediaZoomModal.show();
        
      });
    });
  };
  
  /* ── Desktop gallery builder ── */
  function buildMipGallery(carousel, startIdx) {
    startIdx = startIdx || 0;
    var mipEl   = document.getElementById('mip-carousel');
    var mediaEl = mipEl ? mipEl.parentElement : null;
    if (!mediaEl) return;

    // Remove any previous gallery instance
    var old = mediaEl.querySelector('.mip-gallery');
    if (old) old.remove();

    // Collect media (images + video) from carousel slides
    var slides = [].slice.call(carousel.querySelectorAll(':scope > div'));
    var images = [];
    slides.forEach(function(slide) {
      var video = slide.querySelector('video');
      if (video) {
        var srcHtml = '';
        var vsources = slide.querySelectorAll('video source');
        if (vsources.length) {
          [].forEach.call(vsources, function(s){ srcHtml += '<source src="' + s.getAttribute('src') + '"' + (s.getAttribute('type') ? ' type="' + s.getAttribute('type') + '"' : '') + '>'; });
        } else if (video.getAttribute('src')) {
          srcHtml = '<source src="' + video.getAttribute('src') + '">';
        }
        var poster = video.getAttribute('poster') || '';
        images.push({ type: 'video', src: poster, alt: '', zoom: poster, sources: srcHtml });
      } else {
        var img = slide.querySelector('img');
        if (img) {
          images.push({
            type: 'image',
            src:  img.getAttribute('data-src') || img.src,
            alt:  img.alt || '',
            zoom: img.getAttribute('data-zoom') || img.getAttribute('data-src') || img.src
          });
        }
      }
    });
    if (!images.length) return;

    var current      = Math.min(Math.max(0, startIdx), images.length - 1);
    var thumbOffset  = 0;
    var THUMBS_PAGE  = 7;

    // Build gallery DOM
    var gallery = document.createElement('div');
    gallery.className = 'mip-gallery';

    var mainsRow = document.createElement('div');
    mainsRow.className = 'mip-gallery-mains';
    var slotL = document.createElement('div');
    slotL.className = 'mip-gallery-main-slot mip-slot-left';
    var slotR = document.createElement('div');
    slotR.className = 'mip-gallery-main-slot mip-slot-right';
    mainsRow.appendChild(slotL);
    mainsRow.appendChild(slotR);

    // Overlay nav arrows
    var prevNavBtn = document.createElement('button');
    prevNavBtn.type = 'button';
    prevNavBtn.className = 'mip-nav-btn mip-nav-prev';
    prevNavBtn.setAttribute('aria-label', 'Previous image');
    prevNavBtn.innerHTML = '<svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var nextNavBtn = document.createElement('button');
    nextNavBtn.type = 'button';
    nextNavBtn.className = 'mip-nav-btn mip-nav-next';
    nextNavBtn.setAttribute('aria-label', 'Next image');
    nextNavBtn.innerHTML = '<svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    mainsRow.appendChild(prevNavBtn);
    mainsRow.appendChild(nextNavBtn);

    gallery.appendChild(mainsRow);

    var thumbsOuter = document.createElement('div');
    thumbsOuter.className = 'mip-thumbs-outer';
    var thumbPrevBtn = document.createElement('button');
    thumbPrevBtn.type = 'button';
    thumbPrevBtn.className = 'mip-thumb-arrow mip-thumb-prev';
    thumbPrevBtn.setAttribute('aria-label', 'Previous thumbnails');
    thumbPrevBtn.innerHTML = '<svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var thumbsInner = document.createElement('div');
    thumbsInner.className = 'mip-thumbs-inner';
    var thumbNextBtn = document.createElement('button');
    thumbNextBtn.type = 'button';
    thumbNextBtn.className = 'mip-thumb-arrow mip-thumb-next';
    thumbNextBtn.setAttribute('aria-label', 'More thumbnails');
    thumbNextBtn.innerHTML = '<svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    thumbsOuter.appendChild(thumbPrevBtn);
    thumbsOuter.appendChild(thumbsInner);
    thumbsOuter.appendChild(thumbNextBtn);
    gallery.appendChild(thumbsOuter);

    // Insert gallery after #mip-carousel and hide the original
    mipEl.insertAdjacentElement('afterend', gallery);
    mipEl.style.display = 'none';

    function slotMarkup(item, active) {
      if (item.type === 'video') {
        return '<video class="img-fluid mip-video" muted loop playsinline controls' + (active ? ' autoplay' : '') + ' poster="' + (item.src || '').replace(/"/g,'&quot;') + '" style="width:100%;display:block;">' + item.sources + '</video>';
      }
      return '<img src="' + item.src + '" alt="' + (item.alt || '').replace(/"/g,'&quot;') + '" class="img-fluid">';
    }
    function renderMains() {
      var rIdx = (current + 1) % images.length;
      slotL.innerHTML = slotMarkup(images[current], true);
      slotR.innerHTML = slotMarkup(images[rIdx], false);
      var v = slotL.querySelector('video');
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
    }

    function renderThumbs() {
      thumbsInner.innerHTML = '';
      for (var i = 0; i < images.length; i++) {
        var el = document.createElement('div');
        el.className = 'mip-thumb-item' + (i === current ? ' mip-active' : '');
        el.setAttribute('data-idx', i);
        el.innerHTML = '<img src="' + images[i].src + '" alt="' + (images[i].alt || '').replace(/"/g,'&quot;') + '" loading="lazy">' + (images[i].type === 'video' ? '<span class="mip-thumb-play" aria-hidden="true"></span>' : '');
        thumbsInner.appendChild(el);
      }
      updateThumbArrows();
      scrollActiveThumbIntoView();
    }

    /* Show/hide + enable/disable the arrows based on overflow & scroll position */
    function updateThumbArrows() {
      var maxScroll = thumbsInner.scrollWidth - thumbsInner.clientWidth - 1;
      var hasOverflow = maxScroll > 0;
      thumbPrevBtn.style.display = hasOverflow ? 'flex' : 'none';
      thumbNextBtn.style.display = hasOverflow ? 'flex' : 'none';
      thumbPrevBtn.disabled = thumbsInner.scrollLeft <= 0;
      thumbNextBtn.disabled = thumbsInner.scrollLeft >= maxScroll;
    }

    /* Keep the active thumbnail visible within the strip */
    function scrollActiveThumbIntoView() {
      var activeEl = thumbsInner.querySelector('.mip-thumb-item.mip-active');
      if (!activeEl) return;
      var elLeft  = activeEl.offsetLeft;
      var elRight = elLeft + activeEl.offsetWidth;
      if (elLeft < thumbsInner.scrollLeft) {
        thumbsInner.scrollTo({ left: Math.max(0, elLeft - 8), behavior: 'smooth' });
      } else if (elRight > thumbsInner.scrollLeft + thumbsInner.clientWidth) {
        thumbsInner.scrollTo({ left: elRight - thumbsInner.clientWidth + 8, behavior: 'smooth' });
      }
    }

    function scrollThumbsBy(dir) {
      var step = (72 + 8) * 3; /* ~3 thumbnails */
      thumbsInner.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    // Thumbnail click → set as main image
    thumbsInner.addEventListener('click', function(e) {
      var item = e.target.closest('.mip-thumb-item');
      if (!item) return;
      current = parseInt(item.getAttribute('data-idx'), 10);
      renderMains();
      renderThumbs();
    });

    // Left / right thumbnail scroll arrows
    thumbPrevBtn.addEventListener('click', function() { scrollThumbsBy(-1); });
    thumbNextBtn.addEventListener('click', function() { scrollThumbsBy(1); });
    thumbsInner.addEventListener('scroll', updateThumbArrows);
    window.addEventListener('resize', updateThumbArrows);

    // Prev / Next overlay nav arrows
    prevNavBtn.addEventListener('click', function() {
      current = (current - 1 + images.length) % images.length;
      renderMains();
      renderThumbs();
    });
    nextNavBtn.addEventListener('click', function() {
      current = (current + 1) % images.length;
      renderMains();
      renderThumbs();
    });

    // Zoom on main image click
    [slotL, slotR].forEach(function(slot, si) {
      slot.addEventListener('click', function() {
        var zIdx = si === 0 ? current : (current + 1) % images.length;
        if (images[zIdx].type === 'video') return;   /* don't zoom videos */
        var modalEl = document.getElementById('mediaZoom');
        if (!modalEl) return;
        var modalBody = modalEl.querySelector('.modal-body');
        modalBody.innerHTML = '<div style="text-align:center;padding:20px"><img src="' + images[zIdx].zoom + '" style="max-width:100%;max-height:80vh;object-fit:contain" alt=""></div>';
        bootstrap.Modal.getOrCreateInstance(modalEl).show();
      });
    });

    renderMains();
    renderThumbs();
  }

  function initMip() {
    var carousel_element = jQuery('#mip-carousel div.carousel').not('.slick-initialized');

    if ( carousel_element.length > 0 && window.innerWidth < 768 ) {
      // Mobile: restore #mip-carousel, hide any desktop gallery
      var mipEl2 = document.getElementById('mip-carousel');
      if (mipEl2) mipEl2.style.display = '';
      var galleryEl = mipEl2 ? mipEl2.parentElement.querySelector('.mip-gallery') : null;
      if (galleryEl) galleryEl.remove();

      carousel_element.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        touchMove: true,
        arrows: true,
        dots: true,
        prevArrow: '<button class="slick-prev" type="button" aria-label="Previous"><svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next" type="button" aria-label="Next"><svg class="hx-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      });
      /* Recalc slide widths so each fills the viewport (fixes the next-image peek) */
      setTimeout(function(){ try { carousel_element.slick('setPosition'); } catch(e){} }, 60);
      jQuery(window).on('load', function(){ try { carousel_element.slick('setPosition'); } catch(e){} });

    } else if ( carousel_element.length > 0 && window.innerWidth >= 768 ) {
      // Desktop: custom 2-main + thumbnails gallery
      buildMipGallery(carousel_element[0], window._mipStartIdx || 0);
    }
  }

  function updateHistoryState() {
    var querystring = new URLSearchParams(window.location.search)
    querystring.set('variant', variantObj.id);
    /* querystring.set('selling_plan', (sellingPlan)?sellingPlan.selling_plan_id:''); */
    querystring = '?' + querystring.toString();
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + querystring;
    window.history.replaceState({path: newurl}, '', newurl);
  };

  function getVariant( variantId=false ) {
    var currentVariant = (variantObj)?variantObj:false;
    if( !variantId ) { variantId = document.querySelector('form [name="id"]').value; }
    if( currentVariant && currentVariant.id == variantId ) {
      variantObj = variantObj;
      return variantObj;
    } else {
      var variants = productObj.variants;
      var variant = variants.find(({ id }) => id === Number(variantId));
      variantObj = variant;
      return variant;
    };
  };

  function getVariantMetafields( variantId=false ) {
    if( !variantId ) { variantId = document.querySelector('form [name="id"]').value; }
    return metafieldObj.find(({ id }) => id === Number(variantId));
  };

  function changeSpecs(variantId) {
    var variantMetafields = getVariantMetafields(variantId);
    variantMetafields = variantMetafields.specifications[0];
    var ele = document.querySelector('.specifications');
    if( ele && variantMetafields!=null && typeof variantMetafields  === 'object' ) {
      Object.keys(variantMetafields).forEach(function(key,index, value) {
        if(key == 'product') { return; }
        var classTarget = (key.includes('packed'))?'.packed':'.assembled';
        var metaValue = variantMetafields[key];
        var targetEle = ele.querySelector('.'+key.replace('packed_','')+' '+classTarget);
        targetEle.innerHTML = '<span>'+metaValue[0].value+'</span><span>'+metaValue[0].unit+'</span>';
      });   
    };
  };
  
  /* JS loaded: hide dropdown and show option swap */
  document.querySelector('.variant-select').style.display = "none";
  var options_ele = document.querySelectorAll('.product-options');
  [].forEach.call(options_ele, function(ele) {
    ele.style.display = "block";
  });

  jQuery('.product-options :radio, .product-options select').on('change', function () {

    if( jQuery(this).is("input") ) {
      jQuery("#selected-option-"+jQuery(this).attr('name').toLowerCase().replace(/ /g,'-')).text( jQuery(this).val() );
    }

    /* loop through all available options and get currently selected value */
    
    var selected_options = [];
    productObj.options.forEach(async function(option) {
      if( document.querySelector('[data-option="'+option+'"] input') ) {
        selected_options.push( document.querySelector('[data-option="'+option+'"] input:checked').value );
      } else if(document.querySelector('[data-option="'+option+'"] select') ) {
        selected_options.push( document.querySelector('[data-option="'+option+'"] select').value );
      }
    });

    /* find variant by selected value(s) */
    var selected_variant = productObj.variants.find(function(variant, index) {
      if(selected_options.length == 3 && variant.option1 == selected_options[0] && variant.option2 == selected_options[1] && variant.option3 == selected_options[2] ) {
        return true;
      } else if(selected_options.length == 2 && variant.option1 == selected_options[0] && variant.option2 == selected_options[1] ) {
        return true;
      } else if(selected_options.length == 1 && variant.option1 == selected_options[0]) {
        return true;
      } else {
		return false;
	  }
    });

	/* If variant does't exist, show as sold out w/o notify ability */
    if(!selected_variant) { 
		//alert("That combination isn't available. Choose another option.");
        updateCTA( false );
		jQuery('.klaviyo-bis-trigger').hide();
		return false;
	};

    setVariant( selected_variant );
    changeSpecs( selected_variant.id );
  });

  /* Move the title above the gallery only when the layout is actually stacked
     (<768). On iPads (768-991) the columns are side by side, so the title
     must stay inside the description column. matchMedia matches the CSS
     breakpoint exactly (jQuery width() excludes the scrollbar). */
  if (window.matchMedia('(max-width: 767.98px)').matches) {
    jQuery('#product_header').prependTo(".product-header > div > div.d-flex");
    jQuery('#product_header').addClass("content");
  };

  /* The gallery (slick on mobile, two-image gallery on desktop) and the title
     placement are chosen at load time. Re-apply both whenever the viewport
     crosses the 768px breakpoint so no refresh is needed. */
  var _hxMobileMQ  = window.matchMedia('(max-width: 767.98px)');
  var _hxWasMobile = _hxMobileMQ.matches;
  var _hxResizeTimer;
  jQuery(window).on('resize', function(){
    clearTimeout(_hxResizeTimer);
    _hxResizeTimer = setTimeout(function(){
      var nowMobile = _hxMobileMQ.matches;
      if (nowMobile === _hxWasMobile) return;
      _hxWasMobile = nowMobile;

      var $carousel = jQuery('#mip-carousel div.carousel');
      var mipEl     = document.getElementById('mip-carousel');

      if (nowMobile) {
        /* Desktop → mobile: drop the desktop gallery, show the slick carousel */
        var galleryEl = mipEl ? mipEl.parentElement.querySelector('.mip-gallery') : null;
        if (galleryEl) galleryEl.remove();
        if (mipEl) mipEl.style.display = '';
        if ($carousel.length && !$carousel.hasClass('slick-initialized')) {
          initMip();
        }
        /* Title above the gallery (stacked layout) */
        jQuery('#product_header').prependTo('.product-header > div > div.d-flex').addClass('content');
      } else {
        /* Mobile → desktop: unslick and build the two-image gallery */
        if ($carousel.length && $carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
        initMip();
        /* Title back inside the description column */
        jQuery('#product_header').removeClass('content').prependTo('.product-header .description > .content');
      }
    }, 250);
  });

  setVariant(variantObj);


  } catch(e) { console.error(e); }
})();
})();
